import React from 'react';

export const ArrowIcon: React.FC<sharedComponents.SvgIcon> = ({
  width = 22,
  height = 12,
  className = '',
  color = '#5514B4',
}) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    className={className}
    viewBox="0 0 22 12"
  >
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.71967 0.59467C1.01256 0.301777 1.48744 0.301777 1.78033 0.59467L11 9.81434L20.2197 0.59467C20.5126 0.301777 20.9874 0.301777 21.2803 0.59467C21.5732 0.887563 21.5732 1.36244 21.2803 1.65533L11 11.9357L0.71967 1.65533C0.426777 1.36244 0.426777 0.887563 0.71967 0.59467Z"
    />
  </svg>
);
